<template lang="pug">
    v-autocomplete.currency-selector(v-model="select" solo dense outlined no-filter :rules="rules" :search-input.sync="search" item-value="code" :items="items"  :placeholder="$t('Placeholder.__Currency')" @change="onchange" :disabled="disabled" :readonly="readonly" :hint="hint" persistent-hint)
        template(v-slot:item="{ item, index }")
            .text {{item.code + " - " + $t("Currency." + item.code)}}
        template(v-slot:selection="{ item, index }")
            .text {{item.code + " - " + $t("Currency." + item.code)}}
</template>
<script>
// test data
import currenciesJSON from "@/assets/json/currencies.json"

export default {
  props: {
    value: {
      type: String
    },
    rules: {
      type: Array,
      default: function() {
        return []
      }
    },
    onchange: {
      type: Function,
      default: function(val) {}
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    hint: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      search: null,
      items: currenciesJSON,
      select: "",
      currencies: currenciesJSON
    }
  },
  watch: {
    search(val) {
      val && val !== this.select && this.querySelections(val)
    },
    value(val) {
      this.select = val
    },
    select(val) {
      if (val) {
        this.$emit("input", val)
      }
    }
  },
  methods: {
    querySelections(val) {
      this.items = this.currencies.filter(item => {
        return (
          (item.name || "").toLowerCase().indexOf((val || "").toLowerCase()) > -1 ||
          (item.code || "").toLowerCase().indexOf((val || "").toLowerCase()) > -1
        )
      })
      if (val == "") {
        this.items = this.currencies
      }
    }
  },
  mounted() {
    this.select = this.value
  }
}
</script>
